module.exports = __webpack_public_path__ + "static/media/lamp-floor.3cf40ef2.svg";